<template>
  <div class="header">
    <transition name="mobile-menu">
      <div v-if="currentMenuOptions" class="mobile-menu-field col-block width-full" :style="{ '--mobile-menu-length': 5 + 'px' }" @click="e => currentMenu = null">
        <div class="mobile-menu-container col-block width-full">
          <div
            v-for="(menuOptions, moindex) in currentMenuOptions"
            :key="moindex"
            class="mobile-menu-block col-block width-full"
            @click.stop
          >
            <div class="mobile-menu-content-container col-block width-full" :style="{ 'max-width': '250px' }">
              <router-link
                class="mobile-menu-content-block center-block"
                :to="menuOptions.options[0].to"
                :class="{ active: menuOptions.options.some(option => option.active) }"
              >
                <div class="mobile-menu-content">{{ menuOptions.title }}</div>
              </router-link>
              <component
                v-for="(option, oindex) in menuOptions.options"
                :key="oindex"
                class="mobile-menu-content-block center-block"
                :is="option.to ? 'router-link' : 'div'"
                :to="option.to"
                :class="{ active: option.active }"
                @click.stop="e => { currentMenu = null; !option.to && option.func() }"
              >
                <div class="mobile-menu-content">{{ option.title }}</div>
              </component>
            </div>
          </div>
          <div class="mobile-menu-block col-block width-full">
            <div class="mobile-menu-button-container col-block">
              <a :href="expertData.url" target="_blank">
                <button class="main-button circle-button padding-button row-block" :style="{ '--padding': '20px' }">
                  <div :style="{ flex: 1 }"></div>
                  <img :src="require('../../assets/buttonIcons/expert-button-icon.svg')" alt="">
                  <div :style="{ width: '10px' }"></div>
                  <span>{{ expertData.title }}</span>
                  <div :style="{ flex: 1 }"></div>
                </button>
              </a>
            </div>
          </div>
        </div>
        <div :style="{ flex: 1 }"></div>
      </div>
    </transition>
    <div class="header-field col-block width-full">
      <div class="header-container col-block width-full">
        <div class="header-block row-block">
          <div class="left-container row-block" :style="{ flex: 1 }">
            <router-link :to="{ name: 'main' }" class="main-text-logo-container center-block">
              <img :src="require('../../assets/images/main-text-logo.svg')" alt="" :style="{ 'max-width': isMobile ? '145.5px' : '208px' }">
            </router-link>
            <div :style="{ flex: 1 }"></div>
          </div>
          <div class="center-container">
          </div>
          <div class="right-container row-block" :style="{ flex: 1 }">
            <div :style="{ flex: 1 }"></div>
            <template v-if="!isMobile">
              <div class="menu-list-container row-block" :class="{ active: productMenuOptions.options.some(option => option.active) }" @click="e => $router.push(productMenuOptions.options[0].to)">
                <div class="menu-list-block menu-trigger col-block" :style="{ '--container-width': '100px' }">
                  <div :style="{ flex: 1 }"></div>
                  <div class="menu-list-button row-block">
                    <div class="menu-list-button-text">{{ productMenuOptions.title }}</div>
                  </div>
                  <div class="menu-list">
                    <div v-if="!isMobile" class="menu-field col-block">
                      <div :style="{ height: '5px' }"></div>
                      <div class="menu-container col-block stretch">
                        <component
                          v-for="(option, index) in productMenuOptions.options"
                          :key="index"
                          :is="option.to ? 'router-link' : 'div'"
                          :to="option.to"
                          class="menu-block row-block"
                          :class="{ active: option.active }"
                          @click.stop="e => !option.to && option.func()"
                        >
                          <div :style="{ flex: 1 }"></div>
                          <div class="menu-title">{{ option.title }}</div>
                          <div :style="{ flex: 1 }"></div>
                        </component>
                      </div>
                    </div>
                  </div>
                  <div :style="{ flex: 1 }"></div>
                </div>
                <div :style="{ flex: 1 }"></div>
              </div>
              <div class="menu-list-container row-block" :class="{ active: companyMenuOptions.options.some(option => option.active) }" @click="e => $router.push(companyMenuOptions.options[0].to)">
                <div class="menu-list-block menu-trigger col-block" :style="{ '--container-width': '150px' }">
                  <div :style="{ flex: 1 }"></div>
                  <div class="menu-list-button row-block">
                    <div class="menu-list-button-text">{{ companyMenuOptions.title }}</div>
                  </div>
                  <div class="menu-list">
                    <div v-if="!isMobile" class="menu-field col-block">
                      <div :style="{ height: '5px' }"></div>
                      <div class="menu-container col-block stretch">
                        <component
                          v-for="(option, index) in companyMenuOptions.options"
                          :key="index"
                          :is="option.to ? 'router-link' : 'div'"
                          :to="option.to"
                          class="menu-block row-block"
                          :class="{ active: option.active }"
                          @click.stop="e => !option.to && option.func()"
                        >
                          <div :style="{ flex: 1 }"></div>
                          <div class="menu-title">{{ option.title }}</div>
                          <div :style="{ flex: 1 }"></div>
                        </component>
                      </div>
                    </div>
                  </div>
                  <div :style="{ flex: 1 }"></div>
                </div>
                <div :style="{ flex: 1 }"></div>
              </div>
              <div class="button-list-contianer row-block">
                <a :href="expertData.url" target="_blank">
                  <button class="main-button circle-button padding-button row-block" :style="{ '--padding': '20px' }">
                    <div :style="{ flex: 1 }"></div>
                    <img :src="require('../../assets/buttonIcons/expert-button-icon.svg')" alt="">
                    <div :style="{ width: '10px' }"></div>
                    <span>{{ expertData.title }}</span>
                    <div :style="{ flex: 1 }"></div>
                  </button>
                </a>
              </div>
            </template>
            <template v-else>
              <div class="menu-icon-button icon-block" :style="{ '--size': '40px' }" @click="e => currentMenu = (isMobile && !currentMenu ? 'main' : null)">
                <img :src="currentMenu === 'main' ? require('../../assets/menuIcons/menu-close-icon.svg') : require('../../assets/menuIcons/menu-open-icon.svg')" alt="" :style="{ 'max-width': '30px' }">
              </div>
              <div :style="{ width: '0' }"></div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import toastMethods from '../../mixins/toastMethods.vue'
import responsitive from '../../mixins/responsitive.vue'
import locale from '../../mixins/locale.vue'
import loginData from '../../mixins/loginData.vue'
import { dateFormat } from '../../constants/global/util'
import { externalLinkDatas } from '../../constants/global/data'

export default {
  mixins: [
    toastMethods,
    responsitive,
    locale,
    loginData
  ],
  data () {
    return {
      currentMenu: null
    }
  },
  computed: {
    ...mapGetters([
      'isLogin',
      'user',
      'afkCountDown'
    ]),
    currentMenuOptions () {
      let currentMenuOptions = [
        this.productMenuOptions,
        this.companyMenuOptions
      ]
      return this.currentMenu ? currentMenuOptions : null
    },
    // static
    expertData () {
      return {
        title: '専門ツール'/* ___ */,
        url: externalLinkDatas['expert']
      }
    },
    productMenuOptions () {
      return {
        title: '製品'/* ___ */,
        options: [
          {
            title: 'Inherinext'/* ___ */,
            to: { name: 'inherinext' },
            active: ['inherinext'].includes(this.$route.name)
          }
        ]
      }
    },
    companyMenuOptions () {
      return {
        title: '企業情報'/* ___ */,
        options: [
          {
            title: '会社概要'/* ___ */,
            to: { name: 'introduction' },
            active: ['introduction'].includes(this.$route.name)
          }
        ]
      }
    },
    // global
    dateFormat () { return dateFormat }
  },
  watch: {
    '$route' () {
      this.currentMenu = null
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/layout/header.vue